import Vue from "vue";
import CKEditorVue from "ckeditor4-vue";

window.CKEDITOR_BASEPATH = "/ckeditor4/";
window.CKEDITOR_NO_CDN = true;
window.CKEDITOR_DISABLE_WARNING = true;

// console.log("[CK4] Plugin file loaded");

function loadCKEditorScript() {
    return new Promise((resolve, reject) => {
        if (window.CKEDITOR) {
            // console.log("[CK4] CKEDITOR already loaded");
            return resolve();
        }

        const script = document.createElement("script");
        script.src = "/ckeditor4/ckeditor.js";
        script.onload = () => {
            console.log("[CK4] ckeditor.js LOADED", window.CKEDITOR.version);

            window.CKEDITOR.editorConfig = function (config) {
                config.height = 300;
                config.extraPlugins = "justify";

                // NOTE: image-upload config (uploadUrl/filebrowser*) lives in
                // /public/ckeditor4/config.js — CKEditor loads that as customConfig
                // and it OVERRIDES this editorConfig, so upload settings must go
                // there, not here (P26_018 FR-12 / AC-12.2).

                config.toolbar = [
                    { name: 'clipboard', items: ['Undo', 'Redo'] },
                    { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat'] },
                    {
                        name: 'paragraph',
                        items: [
                            'NumberedList', 'BulletedList', '-',
                            'Outdent', 'Indent', '-',
                            'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'
                        ]
                    },
                    { name: 'links', items: ['Link', 'Unlink'] },
                    { name: 'insert', items: ['Image', 'Table', 'HorizontalRule', 'SpecialChar'] },
                    { name: 'styles', items: ['Format', 'Font', 'FontSize'] },
                    { name: 'colors', items: ['TextColor', 'BGColor'] },
                    { name: 'tools', items: ['Maximize', 'ShowBlocks'] }
                ];

                config.removeButtons = 'Subscript,Superscript';
                config.format_tags = 'p;h1;h2;h3;pre';
            };

            resolve();
        };

        script.onerror = () => reject("Gagal load ckeditor.js — cek path /public/ckeditor4/");
        document.head.appendChild(script);
    });
}

loadCKEditorScript().then(() => {
    // daftarkan ckeditor4-vue SETELAH CKEDITOR READY
    Vue.use(CKEditorVue, { componentName: "ckeditor4" });
    console.log("[CK4] Vue plugin registered");
});
